import { render, staticRenderFns } from "./inqueries.vue?vue&type=template&id=4bfedada&"
import script from "./inqueries.vue?vue&type=script&lang=js&"
export * from "./inqueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports